<template>
    <!-- The Modal -->
  <div class="modal fade" id="myModal">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">

        <!-- Modal Header -->
        <div class="modal-header modal-padding border-0">
          <h4 class="modal-title">Frequently Asked Questions</h4>
          <button type="button" class="close" data-bs-dismiss="modal"><span class="close-icon">Close &times;</span></button>
        </div>
        
        <!-- Modal body -->
        <div class="modal-body">
            <div class="accordion accordion-flush" id="accordionFlushExample">
                <div class="accordion-item border mb-3">
                    <h2 class="accordion-header" id="flush-headingOne">
                        <a class="accordion-button collapsed bg-transparent border-bottom-0 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                            What is Lazada Direct Top-Up?
                        </a>
                    </h2>
                    <div id="flush-collapseOne" class="accordion-collapse collapse py-2 px-3" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
                        <p class="text-secondary">
                            Home Credit is offering Qwarta users another way to top-up their Lazada Wallets. With Lazada Direct Top-up, customers will only need to provide their account details and indicate the top-up amount, then the funds will go straight to their Lazada Wallet after payment.  
                            <br />
                            <br />
                            It’s like buying load for your mobile number, except this time, it’s the Lazada Wallet that you’re loading.
                        </p>
                    </div>
                </div>
                <div class="accordion-item border mb-3">
                    <h2 class="accordion-header" id="flush-headingTwo">
                        <a class="accordion-button collapsed bg-transparent border-bottom-0 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
                            Who are eligible to use this Top-up service? 
                        </a>
                    </h2>
                    <div id="flush-collapseTwo" class="accordion-collapse collapse py-2 px-3" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
                        <p class="text-secondary">
                            Only Home Credit customers with active Qwarta and sufficient balance are eligible. Customers will also need an activated Lazada Wallet to receive the funds. 
                            <br />
                            <br />
                            Home Credit Card customers <b>cannot</b> use this service.  
                        </p>
                    </div>
                </div>
                <div class="accordion-item border mb-3">
                    <h2 class="accordion-header" id="flush-headingThree">
                        <a class="accordion-button collapsed bg-transparent border-bottom-0 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
                            How do I top up directly to my Lazada Wallet?
                        </a>
                    </h2>
                    <div id="flush-collapseThree" class="accordion-collapse collapse py-2 px-3" aria-labelledby="flush-headingThree" data-bs-parent="#accordionFlushExample">
                        <p class="text-secondary">
                            You can access the Lazada Direct Top-up service through the Home Credit app or Lazada app.
                            <br />
                            <br />
                            Before making a top-up, please make sure that the nominated Lazada Wallet is activated. If it is not activated, then the top-up would fail and the Lazada Wallet would not receive the funds. 
                            <br /> 
                            <br /> 
                            <b>From the Home Credit app,</b>
                            <ol type="1">
                                <li>
                                    There are two ways to access Lazada here
                                    <ol type="a">
                                        <li>Tap the Lazada icon from the dashboard; or</li>
                                        <li>Tap the Lazada card from the Special Offers carousel</li>
                                    </ol>
                                </li>
                                <li>
                                    On the Denomination screen, enter the preferred amount in the field provided
                                    <ol type="a">
                                        <li>Alternatively, you can choose from a list of default amounts</li>
                                    </ol>
                                </li>
                                <li>Enter the email address or mobile number of the nominated Lazada Wallet in the field provided and press "Continue"</li>
                                <li>Review payment details and confirm</li>
                                <li>Enter PIN for security purposes</li>
                                <li>Check if View Receipt screen confirms the successful top-up</li>
                                <li>
                                    Open your Lazada app and you will see the funds sent to your Lazada Wallet right away
                                    <ol type="a">
                                        <li>Alternatively, you can view your Transactions History to confirm the top-up </li>
                                    </ol>
                                </li>
                            </ol>
                            <b>From the Lazada app,</b>
                            <ol type="1">
                                <li>
                                    Tap the Wallet icon on the upper right side of the screen to open the Lazada Wallet dashboard
                                </li>
                                <li>
                                    Tap Loans 
                                </li>
                                <li>Select Home Credit</li>
                                <li>
                                    Enter the mobile number that you use to login to the Home Credit app
                                    <ol type="a">
                                        <li>Only users with active Qwarta will be able to reach this step</li>
                                    </ol>
                                </li>
                                <li>
                                    On the Denomination screen, input the following details:
                                    <ol type="a">
                                        <li>The mobile number or email address connected to the Lazada Wallet that you want to top up; </li>
                                        <li>The top-up amount between P100 and P5000</li>
                                    </ol>
                                </li>
                                <li>Click “Submit”</li>
                                <li>Verify your identity by either tapping the push notification sent by Home Credit or the dashboard banner found in the Home Credit app</li>
                                <li>In the Home Credit app, confirm the purchase details like the recipient and amount </li>
                                <li>Enter PIN for security purposes</li>
                                <li>Check if View Receipt screen confirms the successful top-up </li>
                                <li>
                                    Open your Lazada app and you will see the funds sent to your account right away
                                    <ol type="a">
                                        <li>Alternatively, you can view your Recent Transactions History to confirm the top-up </li>
                                    </ol>
                                </li>
                            </ol>
                            <img alt="" src="/img/lazada/lazada-fqa1.webp" class="image-size-reponsive" />
                        </p>
                    </div>
                </div>
                <div class="accordion-item border mb-3">
                    <h2 class="accordion-header" id="flush-headingFour">
                        <a class="accordion-button collapsed bg-transparent border-bottom-0 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFour" aria-expanded="false" aria-controls="flush-collapseFour">
                            When will the top-up amount reflect in my Lazada Wallet?
                        </a>
                    </h2>
                    <div id="flush-collapseFour" class="accordion-collapse collapse py-2 px-3" aria-labelledby="flush-headingFour" data-bs-parent="#accordionFlushExample">
                        <p class="text-secondary">
                            The amount will reflect in the nominated Lazada Wallet in <b>real-time</b>.
                        </p>
                    </div>
                </div>
                <div class="accordion-item border mb-3">
                    <h2 class="accordion-header" id="flush-headingFive">
                        <a class="accordion-button collapsed bg-transparent border-bottom-0 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFive" aria-expanded="false" aria-controls="flush-collapseFive">
                            How much can I top up into my Lazada Wallet?
                        </a>
                    </h2>
                    <div id="flush-collapseFive" class="accordion-collapse collapse py-2 px-3" aria-labelledby="flush-headingFive" data-bs-parent="#accordionFlushExample">
                        <p class="text-secondary">
                            Home Credit allows Qwarta customers to top-up from P100 to P5000 per transaction. 
                            <br />
                            <br />
                            Furthermore, Lazada puts a limit of P100,000 (including refunds and rebate balances) per month for Lazada Wallet. 
                            <br />
                            <br />
                            For other Lazada Wallet questions, please check out <a href="https://www.lazada.com.ph/helpcenter/lazada-wallet-faq-12216.html?spm=a2o4l.helpcenter-search.article.1.201f72ebayfmFr" target="_new">Lazada FAQs.</a>  
                        </p>
                    </div>
                </div>
                <div class="accordion-item border mb-3">
                    <h2 class="accordion-header" id="flush-headingSix">
                        <a class="accordion-button collapsed bg-transparent border-bottom-0 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseSix" aria-expanded="false" aria-controls="flush-collapseSix">
                            Will the top-up value expire? 
                        </a>
                    </h2>
                    <div id="flush-collapseSix" class="accordion-collapse collapse py-2 px-3" aria-labelledby="flush-headingSix" data-bs-parent="#accordionFlushExample">
                        <p class="text-secondary">
                            Once the amount has been sent to the nominated Lazada Wallet, the value does not expire. 
                            <br />
                            <br />
                            The amount topped up doesn’t have to be spent immediately. It can be used for future purchases.
                        </p>
                    </div>
                </div>
                <div class="accordion-item border mb-3">
                    <h2 class="accordion-header" id="flush-headingSeven">
                        <a class="accordion-button collapsed bg-transparent border-bottom-0 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseSeven" aria-expanded="false" aria-controls="flush-collapseSeven">
                            Do I need to install an app to enjoy this service?
                        </a>
                    </h2>
                    <div id="flush-collapseSeven" class="accordion-collapse collapse py-2 px-3" aria-labelledby="flush-headingSeven" data-bs-parent="#accordionFlushExample">
                        <p class="text-secondary">
                            Yes, you need to download the Home Credit app to enjoy this service. You may download the Home Credit app in Google Play and App Store. 
                        </p>
                    </div>
                </div>
                <div class="accordion-item border mb-3">
                    <h2 class="accordion-header" id="flush-headingEight">
                        <a class="accordion-button collapsed bg-transparent border-bottom-0 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseEight" aria-expanded="false" aria-controls="flush-collapseEight">
                            How will I know if my Lazada Wallet is activated?
                        </a>
                    </h2>
                    <div id="flush-collapseEight" class="accordion-collapse collapse py-2 px-3" aria-labelledby="flush-headingEight" data-bs-parent="#accordionFlushExample">
                        <p class="text-secondary">
                            Please follow these steps:
                            <ol type="1">
                                <li>Open your Lazada app.</li>
                                <li>Tap the Wallet icon on the upper right of the screen. </li>
                                <li>
                                    You will see the Lazada Wallet landing page.
                                    <ol type="a">
                                        <li>If you see the “Cash in” button, then it means that your Lazada Wallet has been activated.</li>
                                        <li>If you see the “Activate” button, then it means that your Lazada Wallet has <b>not</b> been activated.</li>
                                    </ol>
                                </li>
                                <li>If your account has not been activated, tap the “Activate” button and verify your wallet via OTP.</li>
                            </ol>
                            <img alt="" src="/img/lazada/lazada-fqa2.webp" class="image-size-reponsive" />
                        </p>
                    </div>
                </div>
                <div class="accordion-item border mb-3">
                    <h2 class="accordion-header" id="flush-headingNine">
                        <a class="accordion-button collapsed bg-transparent border-bottom-0 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseNine" aria-expanded="false" aria-controls="flush-collapseNine">
                            I entered an incorrect mobile number or email address, so I didn't receive the top-up amount. Can I request for a refund?
                        </a>
                    </h2>
                    <div id="flush-collapseNine" class="accordion-collapse collapse py-2 px-3" aria-labelledby="flush-headingNine" data-bs-parent="#accordionFlushExample">
                        <p class="text-secondary">
                            Unfortunately, we do not honor refund requests of this nature. We consider Lazada Wallet Top-up transactions as valid and final, so please double-check the mobile number or email address before proceeding with the payment.   
                        </p>
                    </div>
                </div>
                <div class="accordion-item border mb-3">
                    <h2 class="accordion-header" id="flush-headingTen">
                        <a class="accordion-button collapsed bg-transparent border-bottom-0 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTen" aria-expanded="false" aria-controls="flush-collapseTen">
                            The Lazada Wallet that I tried topped up is not yet activated. Will my Qwarta account be charged?
                        </a>
                    </h2>
                    <div id="flush-collapseTen" class="accordion-collapse collapse py-2 px-3" aria-labelledby="flush-headingTen" data-bs-parent="#accordionFlushExample">
                        <p class="text-secondary">
                            No, we will not deduct from your Qwarta account. If you tried topping up an inactive Lazada Wallet, then the transaction would not push through. Your Qwarta account would not be charged.
                            <br />
                            <br />
                            However, in case you were erroneously charged, please reach out to our customer service, so we can reverse it.
                        </p>
                    </div>
                </div>
                <div class="accordion-item border mb-3">
                    <h2 class="accordion-header" id="flush-headingEleven">
                        <a class="accordion-button collapsed bg-transparent border-bottom-0 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseEleven" aria-expanded="false" aria-controls="flush-collapseEleven">
                            I do not know the registered mobile number and/or email address of the Lazada Wallet that I’m topping up. Where can I find this information?
                        </a>
                    </h2>
                    <div id="flush-collapseEleven" class="accordion-collapse collapse py-2 px-3" aria-labelledby="flush-headingEleven" data-bs-parent="#accordionFlushExample">
                        <p class="text-secondary">
                            To view your Lazada account information, please do the following:
                            <ol type="1">
                                <li>Open your Lazada app</li>
                                <li>Click <b>Account</b> on the bottom right corner of the screen</li>
                                <li>Go to <b>Settings</b> and tap <b>Account Information</b></li>
                                <li>On the Account Information screen, you will see the mobile number and email address that are connected to the Lazada Wallet</li>
                            </ol>
                            Please take note of these two details when topping up Lazada Wallets via Home Credit. 
                            <br />
                            <br />
                            For more questions on Lazada account information, you may visit <a href="https://www.lazada.com.ph/helpcenter/lazada-wallet-faq-12216.html?spm=a2o4l.helpcenter-search.article.1.201f72ebayfmFr" target="_new">Lazada FAQs.</a> 
                        </p>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
    methods: {
        data() {
            return {
                oneIsActive: false,
                
            }
        },
        cancelRequest() {
            var vm = this;

            axios
                .post("hcpay/cancel_request?tid=" + this.tid)
                .then(response => {
                    this.$root.$data.view = "lazada-user-canceled";
                })
                .catch(error => {
                    this.$root.$data.view = "lazada-technical-issue";
                });
        }
    }
}
</script>
<style scoped>
.modal-padding {
    padding: 24px;
}
.close-icon {
    color: #E11931;
    font-size: 18px;
}
a {
    color: #000;
    
}
.collapse-header {
    overflow: hidden;
}
.card-title-collapse {
    background: #fff;
    padding: 12px 0 12px 12px;
    font-size: 16px;
    font-weight: bold;
    float: left;
    width: 90%;
}
.card-arrow-collapse {
    float: right;
    width: 10%;
    text-align: right;
    padding: 10px 12px 12px 12px;
}
.card-link[data-toggle="collapse"] b.arrow:before {
    content: "\f106";    /* angle-down */
    font-family: 'Font Awesome 5 Free';
}
.card-link[data-toggle="collapse"].collapsed b.arrow:before {
    content: "\f107";    /* angle-up */
    font-family: 'Font Awesome 5 Free';
}
.faq-link-content {
    color: #49B672;
    font-weight: bold;
}
.image-size-reponsive {
    width: 100%;
}
</style>
